import { render, staticRenderFns } from "./SupplierView.vue?vue&type=template&id=289a8040&scoped=true&"
import script from "./SupplierView.vue?vue&type=script&lang=ts&"
export * from "./SupplierView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289a8040",
  null
  
)

export default component.exports